export default __webpack_public_path__ + "static/media/01_DAIF_Data_03_02.5be811f7.mp4";